import { render, staticRenderFns } from "./settle-account-management.vue?vue&type=template&id=4b104ed7"
import script from "./settle-account-management.vue?vue&type=script&lang=ts"
export * from "./settle-account-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports